import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from "src/environments/environment"


@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handle(request, next))
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    const access_token = await this._authService.getAccessToken();
    const id_token = await this._authService.getIdToken();
    const authReq = req.clone({
      setHeaders: {
        "accesstoken": access_token,
        "idtoken": id_token
      }
    });
    // Important: Note the .toPromise()
    return next.handle(authReq).toPromise();
  }
}
